export const DASHBOARD_PERIODS = [
  'Today',
  'Yesterday',
  'YTD',
  // 'Last YTD',
  'WTD',
  // 'Last WTD',
  'MTD',
  // 'Last MTD',
  'Custom',
];
